/**
 * PLP sofa sizes comparison modal for Combined collection cards.
 * Trigger: .card-sizeinfo--trigger on sofas PLP.
 * Data: /collections/{handle}?view=sofa-sizes
 */

const SOFA_SIZES_CACHE = new Map();

function getSofaSizesModal() {
  return document.getElementById('PlpSofaSizesModal');
}

function lockSofaSizesScroll(lock) {
  document.documentElement.classList.toggle('plp-SofaSizes--open', lock);
  document.body.style.overflow = lock ? 'hidden' : '';
}

async function fetchSofaSizes(handle) {
  if (!handle) return null;
  if (SOFA_SIZES_CACHE.has(handle)) return SOFA_SIZES_CACHE.get(handle);

  const promise = fetch(`/collections/${handle}?view=sofa-sizes`)
    .then((res) => {
      if (!res.ok) throw new Error(`sofa-sizes ${res.status}`);
      return res.json();
    })
    .catch(() => null);

  SOFA_SIZES_CACHE.set(handle, promise);
  return promise;
}

function renderSofaSizeCard(item) {
  const widthHtml =
    item.width != null && String(item.width).trim() !== ''
      ? `<p class="plp-SofaSizes_Width">Total Width: ${escapeHtml(String(item.width).trim())}cm</p>`
      : '';

  const imageHtml = item.image
    ? `<img src="${escapeAttr(item.image)}" alt="${escapeAttr(item.image_alt || item.label || '')}" width="300" height="375" loading="lazy" decoding="async">`
    : '';

  return `<a class="plp-SofaSizes_Card" href="${escapeAttr(item.url || '#')}">
    <span class="plp-SofaSizes_Media">${imageHtml}</span>
    <p class="plp-SofaSizes_Name">${escapeHtml(item.label || item.title || '')}</p>
    <p class="plp-SofaSizes_Price">${escapeHtml(item.price || '')}</p>
    ${widthHtml}
  </a>`;
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function escapeAttr(value) {
  return escapeHtml(value).replace(/'/g, '&#39;');
}

function populateSofaSizesModal(data) {
  const modal = getSofaSizesModal();
  if (!modal || !data) return false;

  const titleEl = modal.querySelector('#PlpSofaSizesTitle');
  const gridEl = modal.querySelector('[data-el="sofa-sizes.grid"]');
  if (!gridEl) return false;

  if (titleEl && data.title) titleEl.textContent = data.title;

  const sizes = Array.isArray(data.sizes) ? data.sizes : [];
  if (!sizes.length) {
    gridEl.innerHTML = `<p class="plp-SofaSizes_Empty">No sizes available.</p>`;
    return true;
  }

  gridEl.innerHTML = sizes.map(renderSofaSizeCard).join('');
  return true;
}

function openSofaSizesModal() {
  const modal = getSofaSizesModal();
  if (!modal) return;

  modal.hidden = false;
  modal.setAttribute('aria-expanded', 'true');
  lockSofaSizesScroll(true);

  const dialog = modal.querySelector('.plp-SofaSizes_Dialog');
  window.requestAnimationFrame(() => dialog?.focus?.());
}

function closeSofaSizesModal() {
  const modal = getSofaSizesModal();
  if (!modal) return;

  modal.setAttribute('aria-expanded', 'false');
  lockSofaSizesScroll(false);

  window.setTimeout(() => {
    if (modal.getAttribute('aria-expanded') === 'false') modal.hidden = true;
  }, 320);
}

async function onSofaSizesTriggerClick(event) {
  const trigger = event.target.closest('.card-sizeinfo--trigger');
  if (!trigger) return;
  if (trigger.disabled || trigger.classList.contains('card-sizeinfo--static')) return;

  event.preventDefault();
  event.stopPropagation();

  const handle = trigger.getAttribute('data-sofa-sizes-handle');
  if (!handle) return;

  trigger.setAttribute('aria-busy', 'true');
  const data = await fetchSofaSizes(handle);
  trigger.removeAttribute('aria-busy');

  if (!populateSofaSizesModal(data)) return;
  openSofaSizesModal();
}

function bindSofaSizesModal() {
  if (document.documentElement.dataset.sofaSizesBound === 'true') return;
  document.documentElement.dataset.sofaSizesBound = 'true';

  document.addEventListener('click', onSofaSizesTriggerClick);

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-el="sofa-sizes.close"]')) {
      event.preventDefault();
      closeSofaSizesModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const modal = getSofaSizesModal();
    if (modal?.getAttribute('aria-expanded') === 'true') {
      event.preventDefault();
      closeSofaSizesModal();
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bindSofaSizesModal);
} else {
  bindSofaSizesModal();
}

window.openSofaSizesModal = openSofaSizesModal;
window.closeSofaSizesModal = closeSofaSizesModal;
